import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { getEnumValues } from '../../../../../services/common/miscUtils';
import Yup, {
  maxMobileNumberLength,
  minMobileNumberLength,
  regExEmail,
} from '../../../../../services/common/validation';
import { IncomeFrequencyEnum, MaritalStatusEnum, TitleEnum } from '../../../../../types/forms';
import { ContactPersonFormModel_OL } from './formModel';

export const getValidationSchema = (): ObjectSchema<Partial<ContactPersonFormModel_OL>> => {
  return Yup.object({
    title: Yup.string().required(t('validation:required')).oneOf(getEnumValues(TitleEnum)),
    firstName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    lastName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    middleName: Yup.string().unaccentedLetters().lengthBetween(0, 64),
    maritalStatus: Yup.string().requiredWithMsg().oneOf(getEnumValues(MaritalStatusEnum)),
    netMonthlyIncome: Yup.number().requiredWithMsg(),
    incomeFrequency: Yup.string().requiredWithMsg().oneOf(getEnumValues(IncomeFrequencyEnum)),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    phoneNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    email: Yup.string().requiredWithMsg().matches(regExEmail, t('validation:invalidEmail')),
  });
};
